import { render } from "./BlogProjectsSingle.vue?vue&type=template&id=37382e22"
import script from "./BlogProjectsSingle.vue?vue&type=script&lang=js"
export * from "./BlogProjectsSingle.vue?vue&type=script&lang=js"

import "./BlogProjectsSingle.vue?vue&type=style&index=0&id=37382e22&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__